import { monetaryValues } from "../Constants/Colors";

const CURRENCY_CODE_BY_ID = {
  brl: "BRL",
  usd: "USD",
  eur: "EUR",
  pyg: "PYG",
  cad: "CAD",
  chf: "CHF",
  jpy: "JPY",
  aud: "AUD",
  mxn: "MXN",
  sek: "SEK",
  usdc: "USDC",
  usdt: "USDT",
  eurc: "EURC",
  // Stablecoin — never collapse to fiat BRL (brl1 ≠ brl).
  brl1: "BRL1",
};

const CURRENCY_SYMBOL_BY_CODE = {
  BRL: "R$",
  USD: "US$",
  EUR: "€",
  GBP: "£",
  PYG: "₲",
  CAD: "CA$",
  CHF: "CHF",
  JPY: "¥",
  AUD: "A$",
  MXN: "MX$",
  SEK: "kr",
  USDC: "US$",
  USDT: "US$",
  EURC: "EURC",
  BRL1: "BRL1",
};

/** Fiat BRL only — not BRL1 (stablecoin wallet asset). */
export const isFiatBrlCurrency = (currency) =>
  String(currency || "").trim().toUpperCase() === "BRL";

export const normalizeCurrencyCode = (currency = "BRL") => {
  const normalized = String(currency || "").trim();
  if (!normalized) return "BRL";

  const byId = CURRENCY_CODE_BY_ID[normalized.toLowerCase()];
  return byId || normalized.toUpperCase();
};

export const getCurrencySymbolByCurrency = (currency = "BRL") => {
  const code = normalizeCurrencyCode(currency);
  return CURRENCY_SYMBOL_BY_CODE[code] || code;
};

export const formatMonetaryValue = (
  value,
  currency = "BRL",
  { minimumFractionDigits = 2, maximumFractionDigits = 2 } = {}
) => {
  const numericValue = Number(value);
  const safeValue = Number.isFinite(numericValue) ? numericValue : 0;
  const signal = safeValue < 0 ? "-" : "";
  const symbol = getCurrencySymbolByCurrency(currency);
  const fractionDigitsMin = Math.min(minimumFractionDigits, maximumFractionDigits);
  const fractionDigitsMax = Math.max(minimumFractionDigits, maximumFractionDigits);
  const formatted = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: fractionDigitsMin,
    maximumFractionDigits: fractionDigitsMax,
  }).format(Math.abs(safeValue));

  return `${signal}${symbol} ${formatted}`;
};

export const formatCurrency = (value, currency, minorUnit = 2) => {
  value = value / 10 ** minorUnit;

  const valueToFormat = value || 0;
  // Fiat formatter only — never pass BRL1 (stablecoin); use formatMonetaryValue instead.
  const isoCurrency = isFiatBrlCurrency(currency) || !currency ? "BRL" : normalizeCurrencyCode(currency);
  const safeIso = isoCurrency === "BRL1" || isoCurrency === "USDC" || isoCurrency === "USDT" || isoCurrency === "EURC"
    ? "BRL"
    : isoCurrency;
  return valueToFormat.toLocaleString("pt-BR", {
    style: "currency",
    currency: safeIso || "BRL",
  });
};

//UNIDADE PARA CENTAVOS
export const convertToCents = (value) => {
  let newValue = stringToDecimal(value);
  return Number(newValue) * 100;
};

export const simpleConvertToCents = (value) => {
  let newValue = value.replace(/\D/g, "");

  return Number(newValue);
};

//CENTAVOS PARA UNIDADE
export const convertToUnity = (value) => {
  let newValue = stringToDecimal(value);
  return Number(newValue) / 100;
};

//STRING PARA DECIMAL
export const stringToDecimal = (value) => {
  if (!value) {
    return 0.0;
  }
  let newValue = String(value);
  if (newValue.length >= 8) {
    newValue = newValue.replace(/\./g, "");
    newValue = newValue.replace(/,/g, ".");
  } else {
    newValue = newValue.replace(/,/g, ".");
  }
  return Number(newValue).toFixed(2);
};

export const formatCurrencyColor = (value) => {
  if (value > 0) {
    return monetaryValues.positive;
  }

  if (value < 0) {
    return monetaryValues.negative;
  }

  return monetaryValues.neutral;
};

export const formatCurrencyType = (value) => {
  if (value >= 0) {
    return "credit";
  }

  if (value < 0) {
    return "debit";
  }
};

export const formatDocument = (value, type) => {
  if (!value || !type) {
    return "";
  }
  switch (type) {
    case "CPF":
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    case "CNPJ":
      return value.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1 $2 $3/$4-$5"
      );
    case "CNPJ_COMPACT":
      return value.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );

    default:
      return value;
  }
};

export const autoFormatDocument = (value) => {
  if (!value ||value=="") {
    return "";
  }
  return formatDocument(value, value.length>11?"CNPJ_COMPACT":"CPF");
};

export const formatPhone = (value, type) => {
  if (!value || !type) {
    return "";
  }
  switch (type) {
    case "CEL":
      return value.replace(/(\d{2})(\d{5})(\d{4})/, "$1 $2-$3");

    default:
      return value;
  }
};

export const orderArrayByName = (a, b) =>
  a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
